import styled, { css } from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { CONTAINER_MAX } from '@/constants/breakpoints';
import { flexCenterAligned, flexColumn, openingEffect } from '@/styles/common';

const commonLinkStyles = css`
  color: var(--textAndLabels-main);
  transition: color 0.3s ease;

  &:hover {
    color: var(--custom-yellow);
  }
`;

export const Wrapper = styled.div`
  z-index: 9;
  display: none;

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    display: block;
  }
`;

export const BarWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 20px 10px 35px;
  background-color: var(--bg-main);
  box-shadow: 0px 4px 12px 0px rgba(13, 10, 44, 0.06);
  z-index: 4;
`;

export const TabItem = styled.button<{ $isActive: boolean }>`
  ${flexCenterAligned}
  background: none;
  border: none;
  flex: 1;
  cursor: pointer;

  svg {
    fill: ${({ $isActive }) =>
      $isActive ? 'var(--textAndLabels-main)' : 'none'};
    color: var(--textAndLabels-main);
    transition: fill 0.3s ease;

    .homeIconInner {
      fill: ${({ $isActive }) =>
        $isActive ? 'var(--bg-main)' : 'var(--textAndLabels-main)'};
    }

    .homeIconOuter {
      fill: ${({ $isActive }) =>
        $isActive ? 'var(--textAndLabels-main)' : 'none'};
    }
  }
`;

export const TopIndicator = styled.div<{ $activeTab: number }>`
  position: absolute;
  top: 0;
  left: ${({ $activeTab }) =>
    `calc(${($activeTab / 5) * 100}% + (${10 - ($activeTab / 5) * 20}px))`};
  width: calc((100% - 20px) / 5);
  height: 5px;
  background-color: var(--textAndLabels-main);
  border-radius: 5px;
  transition: left 0.3s ease;
`;

export const MenuContent = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--bg-main);
  z-index: 3;
  ${flexColumn};
  justify-content: space-between;
  padding: 30px 16px 125px;
  overflow-y: auto;
  ${openingEffect(100)}
`;

export const MenuLinksWrapper = styled.div`
  ${flexColumn};
  margin-bottom: 5px;
`;

export const ThemeSwitcherWrapper = styled.div`
  margin-bottom: 35px;
`;

export const MenuTitle = styled(Typography)`
  padding-bottom: 20px;
`;

export const MenuLink = styled(Typography).attrs({ variant: 'body3' })`
  padding: 16.5px 0;
  ${commonLinkStyles};
`;

export const ContactsAndLanguageWrapper = styled.div`
  ${flexColumn}
  gap: 20px;
`;

export const ContactsTitle = styled(Typography).attrs({ variant: 'body1' })`
  color: var(--textAndLabels-tertiary);
`;

export const ContactsItem = styled(Typography).attrs({ variant: 'body3' })`
  ${commonLinkStyles};
`;
